import React from 'react';
import { cn } from '../../lib/utils';

export function Textarea({ className, ...props }) {
  return (
    <textarea
      className={cn(
        "w-full px-3 py-2 rounded-lg border border-border bg-input text-sm text-foreground",
        "outline-none focus:ring-2 focus:ring-primary/40 resize-none placeholder:text-muted-foreground",
        className
      )}
      {...props}
    />
  );
}
